import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { fadeUp, stagger } from "../../motion";
import "../../css/IntroSection.css";

const STACK = [
  "Firewalls",
  "Routing & Switching",
  "Servers",
  "Active Directory",
  "Endpoint Mgmt",
  "React",
];

const CERTS = ["Microsoft Certified", "ISC2 Certified", "CompTIA A+"];

const IntroSection = () => {
  return (
    <section className="hero">
      <div className="hero__grid container">
        <motion.div
          className="hero__content"
          variants={stagger}
          initial="hidden"
          animate="visible"
        >
          <motion.span className="eyebrow" variants={fadeUp}>
            Hi there, I&apos;m Akinola
          </motion.span>

          <motion.h1 className="hero__title" variants={fadeUp}>
            IT Systems Engineer <br />
            &amp; <span className="text-gradient">Software Developer</span>
            <span className="cursor" aria-hidden="true">_</span>
          </motion.h1>

          <motion.p className="hero__lead" variants={fadeUp}>
            I keep the infrastructure behind modern IT running smoothly —
            firewalls, switches, routers, and servers — and build the software
            on top of it. Bridging dependable systems engineering with clean,
            user-focused development.
          </motion.p>

          <motion.ul className="hero__certs" variants={fadeUp}>
            {CERTS.map((cert) => (
              <li key={cert} className="hero__cert">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <path
                    d="m5 13 4 4L19 7"
                    stroke="currentColor"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                {cert}
              </li>
            ))}
          </motion.ul>

          <motion.div className="hero__actions" variants={fadeUp}>
            <Link to="/Projects" className="btn btn-primary">
              View my work →
            </Link>
            <Link to="/Contact" className="btn btn-ghost">
              Get in touch
            </Link>
          </motion.div>

          <motion.ul className="hero__stack" variants={fadeUp}>
            {STACK.map((tech) => (
              <li key={tech} className="hero__chip">
                {tech}
              </li>
            ))}
          </motion.ul>
        </motion.div>

        <motion.div
          className="hero__visual"
          initial={{ opacity: 0, scale: 0.96, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1], delay: 0.2 }}
        >
          <div className="code-card">
            <div className="code-card__bar">
              <span className="code-card__dot" />
              <span className="code-card__dot" />
              <span className="code-card__dot" />
              <span className="code-card__file">engineer.js</span>
            </div>
            <pre className="code-card__body">
              <code>
                <span className="tok-kw">const</span>{" "}
                <span className="tok-var">akinola</span> = {"{"}
                {"\n"}
                {"  "}role: <span className="tok-str">"Systems + Software"</span>,
                {"\n"}
                {"  "}location: <span className="tok-str">"Lagos, NG"</span>,
                {"\n"}
                {"  "}experience: <span className="tok-str">"5+ years"</span>,
                {"\n"}
                {"  "}certified: [<span className="tok-str">"Microsoft"</span>,{" "}
                <span className="tok-str">"ISC2"</span>,{" "}
                <span className="tok-str">"A+"</span>],
                {"\n"}
                {"  "}infra: [<span className="tok-str">"firewalls"</span>,{" "}
                <span className="tok-str">"routers"</span>,{" "}
                <span className="tok-str">"servers"</span>],
                {"\n"}
                {"  "}stack: [<span className="tok-str">"React"</span>,{" "}
                <span className="tok-str">"Node"</span>,{" "}
                <span className="tok-str">"SQL"</span>],
                {"\n"}
                {"  "}focus: <span className="tok-str">"reliable, secure systems"</span>,
                {"\n"}
                {"  "}available: <span className="tok-kw">true</span>,
                {"\n"}
                {"  "}<span className="tok-fn">build</span>: () =&gt;{" "}
                <span className="tok-str">"let's ship it"</span>,
                {"\n"}
                {"}"};
              </code>
            </pre>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default IntroSection;
